if (!customElements.get('quick-view-modal')) {
  customElements.define(
    'quick-view-modal',
    class QuickViewModal extends DrawerComponent {
      constructor() {
        super();

        this.classesToRemoveOnLoad = 'drawer--loading';
        this.drawerBody = this.querySelector(this.selector);
      }

      get selector() {
        return '.quick-view__content';
      }

      get requiresBodyAppended() {
        return !(Shopify.designMode && this.closest('.section-group-overlay-quick-view'));
      }

      prepareToShow() {
        super.prepareToShow();
        this.quickview();
      }

      handleAfterShow() {
        super.handleAfterShow();
        document.dispatchEvent(
          new CustomEvent('quick-view:open', {
            detail: { productUrl: this.dataset.productUrl }
          })
        );
      }

      handleAfterHide() {
        super.handleAfterHide();
        const drawerContent = this.querySelector(this.selector);
        drawerContent.innerHTML = '';
        this.classList.add(this.classesToRemoveOnLoad);
      }

      getProductQuickViewSectionId() {
        let sectionId = FoxTheme.QuickViewSectionId || false;

        if (!sectionId) {
          // Get section id from overlay groups.
          const productQuickView = document.querySelector('.section-group-overlay-quick-view');
          if (productQuickView) {
            sectionId = FoxTheme.utils.getSectionId(productQuickView);
          }

          // Cache for better performance.
          FoxTheme.QuickViewSectionId = sectionId;
        }

        return sectionId;
      }

      quickview() {
        // Clear content of ALL other quick view modals to prevent conflicts
        document.querySelectorAll('quick-view-modal .quick-view__content').forEach((content) => {
          if (content !== this.querySelector(this.selector)) {
            content.innerHTML = '';
          }
        });

        const drawerContent = this.querySelector(this.selector);
        const sectionId = this.getProductQuickViewSectionId();
        const sectionUrl = `${this.dataset.productUrl.split('?')[0]}?section_id=${sectionId}`;

        fetch(sectionUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedDoc = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = parsedDoc.querySelector(this.selector);

            const trigger = document.querySelector(`[aria-controls="${this.id}"]`);
            const productCard = trigger?.closest('.product-card');
            if (productCard?.classList.contains('card-brand-chanel') || productCard?.classList.contains('card-brand-dior')) {
              productElement.querySelectorAll('.f-badge--sale').forEach((el) => el.remove());
            }

            this.setInnerHTML(drawerContent, productElement.innerHTML);

            const colorScheme = this.dataset.colorScheme;
            const brandClass = this.dataset.brandClass;
            if (colorScheme || brandClass) {
              const drawerInner = this.querySelector('.drawer__inner');
              if (drawerInner) {
                if (colorScheme) {
                  drawerInner.className = drawerInner.className.replace(/color-scheme-\S+/g, '');
                  drawerInner.classList.add(`color-${colorScheme}`);
                }
                if (brandClass) {
                  drawerInner.className = drawerInner.className.replace(/card-brand-\S+/g, '');
                  drawerInner.classList.add(brandClass);
                }
              }
            }

            FoxTheme.a11y.trapFocus(this, this.focusElement);
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            document.dispatchEvent(
              new CustomEvent('quick-view:loaded', {
                detail: { productUrl: this.dataset.productUrl }
              })
            );
          })
          .catch((e) => {
            console.error(e);
          });
      }

      setInnerHTML(element, innerHTML) {
        // Remove old variant-selects before setting new innerHTML
        const oldVariantSelects = element.querySelectorAll('variant-selects');
        oldVariantSelects.forEach((vs) => vs.remove());

        element.innerHTML = innerHTML;

        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });

        this.classList.remove(this.classesToRemoveOnLoad);
      }

      setInnerHTML(element, innerHTML) {
        element.innerHTML = innerHTML;
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });

        this.classList.remove(this.classesToRemoveOnLoad);
      }
    }
  );
}
